import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {CModulesOverviewComponent} from './cmodules-overview.component';

const routes: Routes = [
  {path: 'cmodules', component: CModulesOverviewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class CModulesOverviewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/cmodules/cmodules-overview/cmodules-overview-routing.module.ts